<template>
	<div class="h-screen flex w-full vx-row no-gutter justify-center o-login" id="page-login">
		<div
			class="vx-col hidden lg:block md:block lg:w-1/3 md:w:w-1/3 bg-secondary"
			:class="{'bg-secondary-gradient': showBrand}"
		>
			<img src="@/assets/images/rutify/login/img-01.png" alt="login" class="mx-auto pr-8" />
			<transition name="bounce">
				<img
					v-show="!showBrand"
					src="@/assets/images/rutify/login/rutify01.png"
					height="55"
					alt="login"
					class="mx-auto pl-32"
				/>
			</transition>
			<img
				src="@/assets/images/rutify/login/logo_oragen.png"
				alt="login"
				class="mx-auto img-rutify--orange"
				:style="`width:${result}px; top: ${top}%; left: ${left}%; position:${position};`"
			/>
			<transition name="bounce">
				<div v-if="showBrand" class="text-center">
					<img :src="companyBrand" alt="login" class="mx-auto img-company-brand" />
					<h1 class="mt-2 font-bold text-white">{{ companyName }}</h1>
				</div>
			</transition>
		</div>
		<div class="vx-col sm:w-full md:w-full lg:w-2/3 md:w:w-2/3 d-theme-dark-bg">
			<div class="pl-24 pt-24 login-tabs-container">
				<div class="vx-card__title pt-2">
					<h4 class="mb-2 title" :class="{'text-secondary': showBrand}" v-text="companyNameTitle"></h4>
					<p class="subtitle">{{ $t("general.LoginDescription") }}</p>
				</div>
			</div>
			<login-firebase :updateCompanyBrand="updateCompanyBrand" :resetAnimation="resetAnimation"></login-firebase>
		</div>
	</div>
</template>

<script>
import LoginJwt from "./LoginJWT.vue";
import LoginFirebase from "./LoginFirebase.vue";

export default {
	components: {
		LoginJwt,
		LoginFirebase,
	},
	data() {
		return {
			showBrand: false,
			result: 307,
			top: 27.7,
			left: 0,
			position: "relative",
			companyBrand: require("@/assets/images/rutify/login/logo_oragen.png"),
			companyName: "",
		};
	},
	computed: {
		companyNameTitle() {
			return this.companyName
				? this.$t("general.WelcomeToRutify") + " / " + this.companyName
				: this.$t("general.WelcomeToRutify");
		},
	},
	methods: {
		updateCompanyBrand({text, url_logo}) {
			if (!url_logo) return;
			this.companyBrand = url_logo;
			this.companyName = text ? text : "";
			this.runAnimation();
			setTimeout(() => {
				this.showBrand = true;
				this.position = "absolute";
			}, 700);
		},
		openLoading() {
			this.$vs.loading();
		},
		runAnimation() {
			this.result = 50;
			this.top = 5;
			this.left = 10;
		},
		resetAnimation() {
			this.companyName = "";
			this.showBrand = false;
			setTimeout(() => {
				this.result = 307;
				this.top = 27.7;
				this.left = 0;
				this.position = "relative";
			}, 700);
		},
	},
};
</script>

<style lang="scss" scoped>
.login-tabs-container {
	min-height: 205px !important;
	margin-top: 2rem;
}

.img-company-brand {
	width: 307px;
	margin-top: 27.7%;
}

.bounce-enter-active {
	animation: bounce-in 1s;
}
.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.25);
	}
	100% {
		transform: scale(1);
	}
}
</style>
